export default __webpack_public_path__ + "static/media/arrecode.752a29e6.png";